import { render, staticRenderFns } from "./waiting_approval.vue?vue&type=template&id=6ca355a8&scoped=true"
import script from "./waiting_approval.vue?vue&type=script&lang=js"
export * from "./waiting_approval.vue?vue&type=script&lang=js"
import style0 from "./waiting_approval.vue?vue&type=style&index=0&id=6ca355a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca355a8",
  null
  
)

export default component.exports